import React from 'react';
import SupplierRanking from '../modules/supplier-assessment/SupplierRanking';

export default function SupplierAssessmentRanking() {
  return <SupplierRanking />;
}
